module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27844",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4332",
      "atom": "static-1.4721",
      "conversations-async-data": "static-2.7308",
      "conversations-error-reporting": "static-1.8525",
      "conversations-internal-pub-sub": "static-1.15612",
      "conversations-internal-schema": "static-1.12270",
      "conversations-message-history": "static-1.11557",
      "conversations-test-sdk": "static-1.10129",
      "conversations-visitor-experience-components": "static-1.21207",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5220",
      "hs-test-utils": "static-1.7618",
      "hubspot-dlb": "static-2.1762",
      "HubStyleTokens": "static-2.11064",
      "I18n": "static-7.1522",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2642",
      "jasmine-runner": "static-1.6087",
      "quartz": "static-1.6490",
      "react-dlb": "static-1.67",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4108",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4173",
      "usage-tracker": "static-1.6985",
      "usage-tracker-core": "static-1.6835",
      "usage-tracker-public": "static-1.6796",
      "viral-links-lib": "static-1.6646",
      "visitor-ui-component-library": "static-1.5774",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4411",
      "conversations-prop-types": "static-1.7081",
      "conversations-visitor-message-history": "static-1.19944",
      "cssUtils": "static-1.678",
      "enviro": "static-4.345",
      "flux-actions": "static-1.293",
      "foundations-components": "static-1-ak-nestedtablestyle.42",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5820",
      "hubspot-url-utils": "static-1.3810",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9277",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.57",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16270",
      "react-utils": "static-2.5025",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7777",
      "signup-constants": "static-1.18052",
      "styled-components": "static-2.64",
      "usage-tracker-multi": "static-1.5399",
      "visitor-ui-component-library-icons": "static-1.5585",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3084",
      "moment": "static-3.26",
      "quartz-config": "static-1.268",
      "quartz-core": "static-1.5709",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4462",
      "foundations-theming": "static-1.4038",
      "UIComponents": "static-3.8011",
      "cv-backend-services": "static-1.1424",
      "immutable-less": "static-1.4281",
      "conversations-skeleton-state": "static-1.6898",
      "crm-events-viz-core": "static-1.31930",
      "customer-agent-discovery-components-lib": "static-1.2037",
      "customer-data-objects": "static-1.7256",
      "data-fetching-client": "static-1.9307",
      "icons": "static-2.601",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4251",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1036",
      "HeadJS": "static-2.674",
      "framer-motion": "static-1.61",
      "hs-test-utils-bend-plugin": "static-1.2729",
      "msw": "static-1.39",
      "testing-library": "static-1.144",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.3964",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7686",
      "HubStyle": "static-2.11372",
      "quartz-i18n": "static-1.165",
      "sassPrefix": "static-1.148",
      "bend-plugin-foundations-components": "static-1-ak-nestedtablestyle.42",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1754",
      "hs-story-utils": "static-1.9064",
      "react-virtualized": "static-2.90",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.885",
      "ui-fonts": "static-1.337",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3587",
      "usage-tracker-anonymous": "static-1.5402",
      "bender-build-tools": "static-1.2756",
      "dispatcher": "static-1.128",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.754",
      "hubspotter-http": "static-1.4325",
      "mobile-manifest-mixins": "static-1.447",
      "quartz-auth": "static-1.165",
      "quartz-head": "static-1.155",
      "quartz-test": "static-1.165",
      "bend-plugin-foundations-theming": "static-1.2521",
      "foundations-theming-base": "static-1.3023",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3764",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2108",
      "content-assistance-lib": "static-1.7227",
      "crm-component-utils": "static-1.38088",
      "crm-display-components": "static-1.23838",
      "crm-fe-perf": "static-1.22524",
      "crm-links": "static-1.5876",
      "crm-message-bus": "static-1.41921",
      "crm-search-service-types": "static-1.815",
      "crm-source-interpretation-lib": "static-1.4964",
      "customer-data-communicator": "static-1.44461",
      "customer-data-email": "static-1.17408",
      "customer-data-filters-ui": "static-1.38316",
      "customer-data-objects-ui-components": "static-1.12628",
      "customer-data-properties": "static-1.50318",
      "customer-data-rte": "static-1.32102",
      "customer-data-ui-utilities": "static-1.9461",
      "draft-plugins": "static-2.21034",
      "file-manager-components": "static-1.22440",
      "FileManagerCore": "static-1.37939",
      "framework-data-schema-resolvers": "static-1.6512",
      "frontend-preferences-client": "static-1.7568",
      "hubspot-apollo-client": "static-1.4513",
      "hubspot-prosemirror": "static-1.17183",
      "object-comments-thread-lib": "static-1.9704",
      "reference-resolvers-lite": "static-1.7722",
      "ui-addon-upgrades": "static-9.17331",
      "universal-associations-select": "static-1.10598",
      "ai-components-ui-library": "static-1.7941",
      "final-form": "static-1.63",
      "inbound-db-properties-service-client": "static-1.3540",
      "property-translator": "static-1.5048",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.75",
      "hub-http-shared-msw-handlers": "static-1.9080",
      "hubspotter-http-shared-msw-handlers": "static-1.9078",
      "superstore": "static-1.4401",
      "ui-addon-video-player": "static-1.8369",
      "ui-coaching-tips": "static-1.27500",
      "card-properties-lib": "static-1.43081",
      "crm-actions": "static-1.5903",
      "crm-cards-data": "static-1.957",
      "crm-cards-sdk": "static-1.42443",
      "customer-data-properties-shared-msw-handlers": "static-1.8407",
      "customer-data-property-utils": "static-1.7696",
      "customer-data-tracking": "static-1.6506",
      "usage-tracker-container": "static-1.6975",
      "framework-data-table": "static-2.11054",
      "location-customization-utils-lib": "static-1.8076",
      "calling-error-reporting": "static-1.30937",
      "calling-internal-common": "static-1.30931",
      "calling-usage-tracker": "static-1.6187",
      "crm_data": "static-4.90713",
      "crm_schema": "static-3.90752",
      "crm-legacy-global-containers": "static-1.23521",
      "customer-data-content": "static-1.26558",
      "draft-content-plugins": "static-1.27384",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23383",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23177",
      "EmailSignatureEditor": "static-1.23643",
      "FileManagerLib": "static-1.38080",
      "hubspot-prosemirror-plugins": "static-1.17175",
      "integration-settings-components": "static-1.14299",
      "integrations-lib": "static-1.14911",
      "integrations-tracking-lib": "static-1.5230",
      "native-integrations-shared-strings": "static-1.7429",
      "nav-meta": "static-1.28473",
      "onboarding-scopes": "static-1.6088",
      "outreach-assistant-email-generation": "static-1.5494",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36717",
      "react-colorpicker": "static-2.9849",
      "react-dnd-compat": "static-1.4272",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7805",
      "rich-text-lib": "static-1.19193",
      "sales-email-signature-service-client": "static-1.3486",
      "sequences-lib": "static-1.7448",
      "timezone-utils": "static-2.4878",
      "ui-addon-i18n": "static-1.10752",
      "ui-addon-iframeable": "static-1.8636",
      "ui-business-units-lib": "static-1.8640",
      "ui-gdpr-components": "static-1.9980",
      "ui-shepherd-react": "static-3.9773",
      "user-context": "static-1.4732",
      "whatsapp-sending-lib": "static-1.4467",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4297",
      "salesImages": "static-1.517",
      "customer-data-filters-ui-msw-helpers": "static-1.20750",
      "customer-data-reference-ui-components": "static-1.12760",
      "FormUrlGenerator": "static-2.4368",
      "framework-builder-read-service-client": "static-1.3692",
      "framework-data-schema-quick-fetch": "static-1.6417",
      "inbound-db-meta-service-client": "static-1.3318",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.610",
      "onboarding-tours": "static-1.16042",
      "reporting-datasets-permissions-lib": "static-1.12541",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21008",
      "calling-global-api": "static-1.63136",
      "calling-lifecycle-internal": "static-1.64518",
      "calling-lifecycle-messages": "static-1.56812",
      "commerce-products-lib": "static-1.8369",
      "conditional-properties-service-client": "static-1.3480",
      "external-options-client-types": "static-1.3827",
      "google-libphonenumber": "static-1.31",
      "inbound-db-associations-writes-service-client": "static-1.2814",
      "inbounddb-objects-service-types": "static-1.3896",
      "meetings-icalendar-utils-lib": "static-1.265",
      "multi-currency-client-types": "static-1.3366",
      "object-builder-ui-client": "static-1.47459",
      "pipeline-validation-client-types": "static-1.3630",
      "property-value-citations": "static-1.932",
      "smart-property-lib": "static-1.5312",
      "tiered-pricing": "static-1.586",
      "ui-addon-form-validation": "static-1.10630",
      "immerable": "static-1.3786",
      "video-components-external": "static-1.10098",
      "video-data-lib": "static-1.33756",
      "audio-components": "static-1.5394",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35591",
      "ui-universal-auth": "static-1.8464",
      "video-components": "static-1.12101",
      "video-embed": "static-1.34590",
      "batch-promise": "static-1.1176",
      "crm-pipelines-api-client-types": "static-1.3811",
      "persist-promise": "static-1.3333",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24273",
      "knowledge-content-types": "static-1.8253",
      "payment-link-components": "static-1.22503",
      "ui-addon-emoji-picker": "static-1.9523",
      "call-summary": "static-1.37827",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9226",
      "feature-store-service-types": "static-1.4176",
      "growth-monetization-service-types": "static-1.4183",
      "merchandise-lib": "static-1.253",
      "purchase-motions-components": "static-1.5211",
      "self-service-api": "static-1.9857",
      "upgrade-management-service-types": "static-1.4167",
      "chatspot-client-types": "static-1.10287",
      "chatspot-core": "static-1.19727",
      "ContentUtils": "static-1.67136",
      "copilot-toolkit": "static-1.10134",
      "growth-onboarding-feedback-components": "static-1.6219",
      "customer-data-sidebar": "static-2.45002",
      "enrichment-properties-lib": "static-1.14430",
      "customer-data-associations": "static-1.6971",
      "deal-intel-decorators": "static-1.762",
      "reporting-data": "static-1.65837",
      "ui-addon-draggable": "static-3.4393",
      "crm-record-cards-service-types": "static-1.3319",
      "crm_universal": "static-1.21430",
      "SalesContentIndexUI": "static-3.8650",
      "signup-ui-lego-core": "static-1.20062",
      "content-embed-lib": "static-1.6986",
      "data-model-builder-lib": "static-1.11121",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5202",
      "ui-extensions-remote-renderer": "static-1.16022",
      "universal-page-editor-lib": "static-1.2642",
      "integrations-error-boundary-lib": "static-1.12326",
      "laboratory-lib": "static-3.6772",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10022",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44901",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15793",
      "sequences-client-types-lib": "static-1.7305",
      "foundations-components-test-utils": "static-1-ak-nestedtablestyle.42",
      "magpie-lib": "static-1.5220",
      "navigation-messaging": "static-1.6163",
      "getting-started-shared-tasks": "static-1.17414",
      "getting-started-shared-tasks-store": "static-1.16532",
      "onboarding-tours-utils": "static-1.108",
      "whatsapp-management-lib": "static-1.7626",
      "growth-data-modal": "static-1.4970",
      "growth-onboarding-confetti": "static-1.2688",
      "growth-onboarding-next-action-utils": "static-1.1117",
      "navigation-components": "static-1.16836",
      "onboarding-tours-client": "static-1.4256",
      "ui-shepherd-tracker": "static-1.7154",
      "shared-worker-versioning": "static-1.10665",
      "calling-orchestration-shared-library": "static-1.34318",
      "products-iframe-lib": "static-1.6931",
      "products-ui-components-shared-msw-handlers": "static-1.9462",
      "breeze-intelligence-kit": "static-1.5084",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9163",
      "fsm": "static-1.3364",
      "policy-lib": "static-1.6439",
      "react-tinymce": "static-1.54189",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53315",
      "tinymce-plugins": "static-1.56429",
      "tinymce-themes": "static-1.55285",
      "content-media-composition-data-lib": "static-1.10753",
      "content-media-compositions": "static-2.14760",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4680",
      "media-bridge-lib": "static-1.18320",
      "content-icons-ui": "static-1.2093",
      "social-insights-client-types": "static-1.20974",
      "outpost": "static-1.3865",
      "commerce-analytics-service-client": "static-1.3317",
      "ui-addon-opt": "static-4.8039",
      "commerce-tours-lib": "static-1.5466",
      "growth-onboarding-reliability": "static-1.4735",
      "sales-checkout-service-client": "static-1.3329",
      "ai-addon-copilot-preview": "static-1.7153",
      "calling-cross-tab-library": "static-1.18895",
      "calling-lifecycle-usage-tracker": "static-1.7746",
      "wootric-nps": "static-1.6556",
      "nav-client-types": "static-1.1964",
      "purchase-motions-api": "static-1.5214",
      "trials-service-types": "static-1.3584",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4432",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2684",
      "card-payment-highlight-lib": "static-1.36086",
      "card-subscription-highlight-lib": "static-1.38500",
      "commerce-billing-lib": "static-1.18056",
      "commerce-contract-lib": "static-1.10620",
      "crm_components": "static-3.90713",
      "invoices-highlight-card-lib": "static-1.53512",
      "orders-highlight-card-lib": "static-1.20515",
      "products-highlight-card-lib": "static-1.16653",
      "project-storage": "static-1.4364",
      "quotes-highlight-card-lib": "static-1.70630",
      "usage-based-billing-components-lib": "static-1.7607",
      "deal-intel-utils": "static-1.766",
      "reporting-client-types": "static-1.2334",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4184",
      "sales-templates-service-types-lib": "static-1.3853",
      "ui-asset-management-lib": "static-1.10477",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9198",
      "collaboration-sidebar": "static-1.56733",
      "conditional-property-settings-modal": "static-1.11609",
      "data-model-commons-lib": "static-1.11537",
      "feedback-loader": "static-1.28576",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6682",
      "property-management-iframe": "static-1.11719",
      "reactflow": "static-1.54",
      "simple-data-table": "static-1.1759",
      "used-in-list-lib": "static-1.6537",
      "visual-association": "static-1.5464",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.57914",
      "ui-extensibility-client-types": "static-1.3604",
      "automation-platform-service-types": "static-1.2406",
      "ContentData": "static-1.67211",
      "email-portal-health-service-types": "static-1.621",
      "marketing-email-service-types": "static-1.1723",
      "reactive-lib": "static-1.358",
      "content-whatsapp-service-types": "static-1.155",
      "marketing-platform-lib": "static-1.6463",
      "short-messages-app-service-client": "static-1.3658",
      "ui-tool-access": "static-1.9768",
      "calling-orchestration-schema": "static-1.34543",
      "sales-views-client-types": "static-1.3925",
      "trellis-story-utils": "static-1.4159",
      "storybook-react": "static-1.25",
      "hub-http-contrib": "static-1.2696",
      "interframe": "static-3.4424",
      "tinymce-data": "static-1.39400",
      "ui-addon-sales-email": "static-1.4849",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11756",
      "layout-dnd-utils": "static-1.10731",
      "react-codemirror": "static-1.10251",
      "ui-brand-identity-lib": "static-1.13252",
      "NamespacedHubStyle": "static-2.8762",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8812",
      "ai-settings-ui-library": "static-1.7075",
      "chirp-fetch": "static-1.1530",
      "copilot-plugins": "static-1.10107",
      "eligibility-engine-service-types": "static-1.2865",
      "commerce-shared-components-lib": "static-1.17488",
      "commerce-subscription-lib": "static-1.36077",
      "commerce-tools-ui-lib": "static-1.9427",
      "usage-tracker-session-replay": "static-1.4671",
      "utility-belt": "static-1.2179",
      "payments-enrollment-embed-lib": "static-1.21431",
      "quotes-ui-lib": "static-1.79348",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6451",
      "invoices-ui-lib": "static-1.53528",
      "commerce-products-api": "static-1.1709",
      "SafeStorage": "static-1.4033",
      "invoices-iframe-lib": "static-1.55586",
      "quotes-modal-lib": "static-1.101305",
      "reporting-ui-components": "static-2.63110",
      "subscription-experience-data-types": "static-1.14361",
      "association-translator": "static-1.2827",
      "crm-settings-header-lib": "static-1.7928",
      "settings-ui-nav": "static-2.9790",
      "chatspot-widget-iframe": "static-1.19719",
      "collaboration-sidebar-common": "static-1.1530",
      "crm-properties-common-lib": "static-1.5503",
      "ui-addon-draggable-compat": "static-2.3902",
      "property-management-common": "static-1.4006",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14568",
      "advanced-menus-lib": "static-1.11572",
      "ExportDialog": "static-6.10032",
      "ui-memberships-settings-lib": "static-1.32993",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9056",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13068",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40285",
      "ui-addon-react-router-dom": "static-1.9185",
      "growth-onboarding-empty-states": "static-1.5140",
      "InboxConnectUtils": "static-4.13821",
      "payments-post-enroll-local-storage-lib": "static-1.4720",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.17056",
      "stripe-embedded-components": "static-1.6879",
      "products-ui-components": "static-1.38888",
      "totals-ui-components": "static-1.22580",
      "reporting-plugins": "static-1.9751",
      "reporting-reports": "static-1.65516",
      "reporting-snowflake": "static-1.54456",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14567",
      "simple-menus-lib": "static-1.16084",
      "academy-common-lib": "static-1.12528",
      "dashboard-lib": "static-1.80017",
      "share-with-third-party-component-lib": "static-1.8323",
      "developer-experience-shared-components": "static-1.10062",
      "marketplace-ui-client-types": "static-1.15929",
      "marketplace-ui-common": "static-1.18522",
      "ui-addon-integrations-directory-panel": "static-2.7624",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.378",
      "property-description-translator": "static-1.3494",
      "commerce-totals-service-types": "static-1.3484",
      "campaign-roi-lib": "static-1.7819",
      "academy-service-client": "static-1.3296",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3520",
      "oauth-service-types": "static-1.3870",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27844",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4332",
      "atom": "/atom/static-1.4721",
      "conversations-async-data": "/conversations-async-data/static-2.7308",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8525",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15612",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12270",
      "conversations-message-history": "/conversations-message-history/static-1.11557",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10129",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21207",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5220",
      "hs-test-utils": "/hs-test-utils/static-1.7618",
      "hubspot-dlb": "/hubspot-dlb/static-2.1762",
      "HubStyleTokens": "/HubStyleTokens/static-2.11064",
      "I18n": "/I18n/static-7.1522",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2642",
      "jasmine-runner": "/jasmine-runner/static-1.6087",
      "quartz": "/quartz/static-1.6490",
      "react-dlb": "/react-dlb/static-1.67",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4108",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4173",
      "usage-tracker": "/usage-tracker/static-1.6985",
      "usage-tracker-core": "/usage-tracker-core/static-1.6835",
      "usage-tracker-public": "/usage-tracker-public/static-1.6796",
      "viral-links-lib": "/viral-links-lib/static-1.6646",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5774",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4411",
      "conversations-prop-types": "/conversations-prop-types/static-1.7081",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19944",
      "cssUtils": "/cssUtils/static-1.678",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.293",
      "foundations-components": "/foundations-components/static-1-ak-nestedtablestyle.42",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5820",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3810",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9277",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.57",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16270",
      "react-utils": "/react-utils/static-2.5025",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7777",
      "signup-constants": "/signup-constants/static-1.18052",
      "styled-components": "/styled-components/static-2.64",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5399",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5585",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3084",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.268",
      "quartz-core": "/quartz-core/static-1.5709",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4462",
      "foundations-theming": "/foundations-theming/static-1.4038",
      "UIComponents": "/UIComponents/static-3.8011",
      "cv-backend-services": "/cv-backend-services/static-1.1424",
      "immutable-less": "/immutable-less/static-1.4281",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6898",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31930",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2037",
      "customer-data-objects": "/customer-data-objects/static-1.7256",
      "data-fetching-client": "/data-fetching-client/static-1.9307",
      "icons": "/icons/static-2.601",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4251",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1036",
      "HeadJS": "/HeadJS/static-2.674",
      "framer-motion": "/framer-motion/static-1.61",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2729",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.144",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.3964",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7686",
      "HubStyle": "/HubStyle/static-2.11372",
      "quartz-i18n": "/quartz-i18n/static-1.165",
      "sassPrefix": "/sassPrefix/static-1.148",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ak-nestedtablestyle.42",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1754",
      "hs-story-utils": "/hs-story-utils/static-1.9064",
      "react-virtualized": "/react-virtualized/static-2.90",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.885",
      "ui-fonts": "/ui-fonts/static-1.337",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3587",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5402",
      "bender-build-tools": "/bender-build-tools/static-1.2756",
      "dispatcher": "/dispatcher/static-1.128",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.754",
      "hubspotter-http": "/hubspotter-http/static-1.4325",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.447",
      "quartz-auth": "/quartz-auth/static-1.165",
      "quartz-head": "/quartz-head/static-1.155",
      "quartz-test": "/quartz-test/static-1.165",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2521",
      "foundations-theming-base": "/foundations-theming-base/static-1.3023",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3764",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2108",
      "content-assistance-lib": "/content-assistance-lib/static-1.7227",
      "crm-component-utils": "/crm-component-utils/static-1.38088",
      "crm-display-components": "/crm-display-components/static-1.23838",
      "crm-fe-perf": "/crm-fe-perf/static-1.22524",
      "crm-links": "/crm-links/static-1.5876",
      "crm-message-bus": "/crm-message-bus/static-1.41921",
      "crm-search-service-types": "/crm-search-service-types/static-1.815",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4964",
      "customer-data-communicator": "/customer-data-communicator/static-1.44461",
      "customer-data-email": "/customer-data-email/static-1.17408",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38316",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12628",
      "customer-data-properties": "/customer-data-properties/static-1.50318",
      "customer-data-rte": "/customer-data-rte/static-1.32102",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9461",
      "draft-plugins": "/draft-plugins/static-2.21034",
      "file-manager-components": "/file-manager-components/static-1.22440",
      "FileManagerCore": "/FileManagerCore/static-1.37939",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6512",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7568",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4513",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17183",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9704",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7722",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17331",
      "universal-associations-select": "/universal-associations-select/static-1.10598",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7941",
      "final-form": "/final-form/static-1.63",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3540",
      "property-translator": "/property-translator/static-1.5048",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.75",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9080",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9078",
      "superstore": "/superstore/static-1.4401",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8369",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27500",
      "card-properties-lib": "/card-properties-lib/static-1.43081",
      "crm-actions": "/crm-actions/static-1.5903",
      "crm-cards-data": "/crm-cards-data/static-1.957",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42443",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8407",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7696",
      "customer-data-tracking": "/customer-data-tracking/static-1.6506",
      "usage-tracker-container": "/usage-tracker-container/static-1.6975",
      "framework-data-table": "/framework-data-table/static-2.11054",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8076",
      "calling-error-reporting": "/calling-error-reporting/static-1.30937",
      "calling-internal-common": "/calling-internal-common/static-1.30931",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6187",
      "crm_data": "/crm_data/static-4.90713",
      "crm_schema": "/crm_schema/static-3.90752",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23521",
      "customer-data-content": "/customer-data-content/static-1.26558",
      "draft-content-plugins": "/draft-content-plugins/static-1.27384",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23383",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23177",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23643",
      "FileManagerLib": "/FileManagerLib/static-1.38080",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17175",
      "integration-settings-components": "/integration-settings-components/static-1.14299",
      "integrations-lib": "/integrations-lib/static-1.14911",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5230",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7429",
      "nav-meta": "/nav-meta/static-1.28473",
      "onboarding-scopes": "/onboarding-scopes/static-1.6088",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5494",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36717",
      "react-colorpicker": "/react-colorpicker/static-2.9849",
      "react-dnd-compat": "/react-dnd-compat/static-1.4272",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7805",
      "rich-text-lib": "/rich-text-lib/static-1.19193",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3486",
      "sequences-lib": "/sequences-lib/static-1.7448",
      "timezone-utils": "/timezone-utils/static-2.4878",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10752",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8636",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8640",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9980",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9773",
      "user-context": "/user-context/static-1.4732",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4467",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4297",
      "salesImages": "/salesImages/static-1.517",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20750",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12760",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4368",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3692",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6417",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3318",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.610",
      "onboarding-tours": "/onboarding-tours/static-1.16042",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12541",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21008",
      "calling-global-api": "/calling-global-api/static-1.63136",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64518",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56812",
      "commerce-products-lib": "/commerce-products-lib/static-1.8369",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3480",
      "external-options-client-types": "/external-options-client-types/static-1.3827",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2814",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3896",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.265",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3366",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47459",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3630",
      "property-value-citations": "/property-value-citations/static-1.932",
      "smart-property-lib": "/smart-property-lib/static-1.5312",
      "tiered-pricing": "/tiered-pricing/static-1.586",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10630",
      "immerable": "/immerable/static-1.3786",
      "video-components-external": "/video-components-external/static-1.10098",
      "video-data-lib": "/video-data-lib/static-1.33756",
      "audio-components": "/audio-components/static-1.5394",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35591",
      "ui-universal-auth": "/ui-universal-auth/static-1.8464",
      "video-components": "/video-components/static-1.12101",
      "video-embed": "/video-embed/static-1.34590",
      "batch-promise": "/batch-promise/static-1.1176",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3811",
      "persist-promise": "/persist-promise/static-1.3333",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24273",
      "knowledge-content-types": "/knowledge-content-types/static-1.8253",
      "payment-link-components": "/payment-link-components/static-1.22503",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9523",
      "call-summary": "/call-summary/static-1.37827",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9226",
      "feature-store-service-types": "/feature-store-service-types/static-1.4176",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4183",
      "merchandise-lib": "/merchandise-lib/static-1.253",
      "purchase-motions-components": "/purchase-motions-components/static-1.5211",
      "self-service-api": "/self-service-api/static-1.9857",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4167",
      "chatspot-client-types": "/chatspot-client-types/static-1.10287",
      "chatspot-core": "/chatspot-core/static-1.19727",
      "ContentUtils": "/ContentUtils/static-1.67136",
      "copilot-toolkit": "/copilot-toolkit/static-1.10134",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6219",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45002",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14430",
      "customer-data-associations": "/customer-data-associations/static-1.6971",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.762",
      "reporting-data": "/reporting-data/static-1.65837",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4393",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3319",
      "crm_universal": "/crm_universal/static-1.21430",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8650",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20062",
      "content-embed-lib": "/content-embed-lib/static-1.6986",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11121",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5202",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16022",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2642",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12326",
      "laboratory-lib": "/laboratory-lib/static-3.6772",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10022",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44901",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15793",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7305",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ak-nestedtablestyle.42",
      "magpie-lib": "/magpie-lib/static-1.5220",
      "navigation-messaging": "/navigation-messaging/static-1.6163",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17414",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16532",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.108",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7626",
      "growth-data-modal": "/growth-data-modal/static-1.4970",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2688",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1117",
      "navigation-components": "/navigation-components/static-1.16836",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4256",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7154",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10665",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34318",
      "products-iframe-lib": "/products-iframe-lib/static-1.6931",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9462",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5084",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9163",
      "fsm": "/fsm/static-1.3364",
      "policy-lib": "/policy-lib/static-1.6439",
      "react-tinymce": "/react-tinymce/static-1.54189",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53315",
      "tinymce-plugins": "/tinymce-plugins/static-1.56429",
      "tinymce-themes": "/tinymce-themes/static-1.55285",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10753",
      "content-media-compositions": "/content-media-compositions/static-2.14760",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4680",
      "media-bridge-lib": "/media-bridge-lib/static-1.18320",
      "content-icons-ui": "/content-icons-ui/static-1.2093",
      "social-insights-client-types": "/social-insights-client-types/static-1.20974",
      "outpost": "/outpost/static-1.3865",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3317",
      "ui-addon-opt": "/ui-addon-opt/static-4.8039",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5466",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4735",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3329",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7153",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18895",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7746",
      "wootric-nps": "/wootric-nps/static-1.6556",
      "nav-client-types": "/nav-client-types/static-1.1964",
      "purchase-motions-api": "/purchase-motions-api/static-1.5214",
      "trials-service-types": "/trials-service-types/static-1.3584",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4432",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2684",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36086",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38500",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18056",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10620",
      "crm_components": "/crm_components/static-3.90713",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53512",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20515",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16653",
      "project-storage": "/project-storage/static-1.4364",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70630",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7607",
      "deal-intel-utils": "/deal-intel-utils/static-1.766",
      "reporting-client-types": "/reporting-client-types/static-1.2334",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4184",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3853",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10477",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9198",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56733",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11609",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11537",
      "feedback-loader": "/feedback-loader/static-1.28576",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6682",
      "property-management-iframe": "/property-management-iframe/static-1.11719",
      "reactflow": "/reactflow/static-1.54",
      "simple-data-table": "/simple-data-table/static-1.1759",
      "used-in-list-lib": "/used-in-list-lib/static-1.6537",
      "visual-association": "/visual-association/static-1.5464",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.57914",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3604",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2406",
      "ContentData": "/ContentData/static-1.67211",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.621",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1723",
      "reactive-lib": "/reactive-lib/static-1.358",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.155",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6463",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3658",
      "ui-tool-access": "/ui-tool-access/static-1.9768",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34543",
      "sales-views-client-types": "/sales-views-client-types/static-1.3925",
      "trellis-story-utils": "/trellis-story-utils/static-1.4159",
      "storybook-react": "/storybook-react/static-1.25",
      "hub-http-contrib": "/hub-http-contrib/static-1.2696",
      "interframe": "/interframe/static-3.4424",
      "tinymce-data": "/tinymce-data/static-1.39400",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4849",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11756",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10731",
      "react-codemirror": "/react-codemirror/static-1.10251",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13252",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8762",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8812",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7075",
      "chirp-fetch": "/chirp-fetch/static-1.1530",
      "copilot-plugins": "/copilot-plugins/static-1.10107",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2865",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17488",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36077",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9427",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4671",
      "utility-belt": "/utility-belt/static-1.2179",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21431",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79348",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6451",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53528",
      "commerce-products-api": "/commerce-products-api/static-1.1709",
      "SafeStorage": "/SafeStorage/static-1.4033",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55586",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101305",
      "reporting-ui-components": "/reporting-ui-components/static-2.63110",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14361",
      "association-translator": "/association-translator/static-1.2827",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7928",
      "settings-ui-nav": "/settings-ui-nav/static-2.9790",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19719",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1530",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5503",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3902",
      "property-management-common": "/property-management-common/static-1.4006",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14568",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11572",
      "ExportDialog": "/ExportDialog/static-6.10032",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32993",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9056",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13068",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40285",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9185",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5140",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13821",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4720",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17056",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6879",
      "products-ui-components": "/products-ui-components/static-1.38888",
      "totals-ui-components": "/totals-ui-components/static-1.22580",
      "reporting-plugins": "/reporting-plugins/static-1.9751",
      "reporting-reports": "/reporting-reports/static-1.65516",
      "reporting-snowflake": "/reporting-snowflake/static-1.54456",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14567",
      "simple-menus-lib": "/simple-menus-lib/static-1.16084",
      "academy-common-lib": "/academy-common-lib/static-1.12528",
      "dashboard-lib": "/dashboard-lib/static-1.80017",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8323",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10062",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15929",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18522",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7624",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.378",
      "property-description-translator": "/property-description-translator/static-1.3494",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3484",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7819",
      "academy-service-client": "/academy-service-client/static-1.3296",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3520",
      "oauth-service-types": "/oauth-service-types/static-1.3870",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};